export default {
    success: {
        on:
      'The new trend universe was successfully updated. This deactivated all outdated trends.<br />\n' +
      'In future, you will receive all updates automatically. You can change your settings at any time.',
        off:
      'Future trend universe updates will no longer be activated automatically.<br />' +
      'You can activate the updates as usual in the Trend Universe overview. You can change your setting at any time.'
    },
    error: 'Sorry, an error has occurred'
}
